<template>
  <span>
    <a
      v-on:click.prevent="openModal"
      class="text-link --plain +text-size-xs"
      href="#"
      >{{ this.anchorText }}</a
    >
    <modal :show="displayModal" @close="closeModal">
      <modal-body>
        <slot></slot>
      </modal-body>
    </modal>
  </span>
</template>

<script>
import { Modal, ModalBody } from '@bankrate/vue-components'
import '@bankrate/vue-components/dist/br-components.css'

export default {
  props: {
    anchorText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      displayModal: false
    }
  },
  methods: {
    openModal() {
      this.displayModal = true
    },
    closeModal() {
      this.displayModal = false
    }
  },
  components: {
    Modal,
    ModalBody
  }
}
</script>

<style lang="scss">
.br-modal .br-modal__dialog {
  overflow-y: scroll;
}
</style>
